import { createAction, props, union } from '@ngrx/store';

export enum WebSocketActionTypes {
  Connect = '[WebSocket] Connect',
  Disconnect = '[WebSocket] Disconnect',
  ConnectionStatusChanged = '[WebSocket] Connection Status Changed',
  ReconnectionFailed = '[WebSocket] Reconnection Failed',
  ReceiveMessage = '[WebSocket] Receive Message',
  SendMessage = '[WebSocket] Send Message',
}

export const connectWebSocket = createAction(WebSocketActionTypes.Connect, props<{ personaId: string }>());
export const disconnectWebSocket = createAction(WebSocketActionTypes.Disconnect);
export const connectionStatusChanged = createAction(WebSocketActionTypes.ConnectionStatusChanged, props<{ connected: boolean }>());
export const reconnectionFailed = createAction(WebSocketActionTypes.ReconnectionFailed);
export const receiveMessage = createAction(WebSocketActionTypes.ReceiveMessage, props<{ message: any }>());
